"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "ImageUpload", {
    enumerable: true,
    get: function() {
        return ImageUpload;
    }
});
var _react = /*#__PURE__*/ _interopRequireWildcard(require("react"));
var _classnames = /*#__PURE__*/ _interopRequireDefault(require("classnames"));
var _icon = require("../Icon");
var _loadingBar = require("../LoadingBar");
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var ImageUpload = function(props) {
    var onChange = props.onChange, className = props.className, initialImgUrl = props.imageUrl, _props_uploading = props.uploading, uploading = _props_uploading === void 0 ? false : _props_uploading;
    var _useState = _slicedToArray((0, _react.useState)(false), 2), dragging = _useState[0], setDragging = _useState[1];
    var _useState1 = _slicedToArray((0, _react.useState)(""), 2), errorMsg = _useState1[0], setErrorMsg = _useState1[1];
    var _useState2 = _slicedToArray((0, _react.useState)(initialImgUrl), 2), imageUrl = _useState2[0], setImageUrl = _useState2[1];
    var onFileChange = function(ev) {
        if (ev.target.files && ev.target.files.length > 0) {
            var file = ev.target.files[0];
            if (file.size > 1024 * 1024 * 10) {
                setErrorMsg("Your file size is over 10MB");
                return;
            }
            setErrorMsg("");
            setImageUrl(URL.createObjectURL(file));
            onChange(file);
        }
    };
    var onRemoveClick = function() {
        setImageUrl("");
        onChange(null);
    };
    var onDragEnter = function() {
        setDragging(true);
    };
    var onDragDone = function() {
        setDragging(false);
    };
    if (uploading) {
        return /*#__PURE__*/ _react.default.createElement("div", {
            className: "mt-1 p-6 pt-5 flex flex-col justify-center items-center border-2 border-gray-300 border-dashed rounded-md",
            style: {
                aspectRatio: "9/3"
            }
        }, /*#__PURE__*/ _react.default.createElement(_loadingBar.LoadingBar, {
            size: "md"
        }), /*#__PURE__*/ _react.default.createElement("span", {
            className: "text-sm text-gray-900 font-medium"
        }, "Uploading..."));
    }
    return /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, imageUrl && /*#__PURE__*/ _react.default.createElement("div", {
        className: "relative mt-1"
    }, /*#__PURE__*/ _react.default.createElement("img", {
        src: imageUrl,
        className: "w-full object-contain",
        style: {
            aspectRatio: "9/3"
        }
    }), /*#__PURE__*/ _react.default.createElement("button", {
        onClick: onRemoveClick,
        className: "border shadow-sm border-gray-200 absolute top-2 right-2 drop-shadow-sm p-2 flex align-middle bg-white rounded-sm border-solid cursor-pointer hover:bg-gray-100",
        style: {
            borderRadius: 6
        }
    }, /*#__PURE__*/ _react.default.createElement(_icon.Delete, {
        className: "text-gray-400",
        style: {
            width: 20
        }
    }))), !imageUrl && /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/ _react.default.createElement("div", {
        className: (0, _classnames.default)("cursor-pointer mt-1 flex justify-center p-6 pt-5 border-2 border-gray-300 border-dashed rounded-md relative", className, {
            "border-accent-500 border-3": dragging,
            "border-red-300": errorMsg
        })
    }, /*#__PURE__*/ _react.default.createElement("div", {
        className: "text-center"
    }, /*#__PURE__*/ _react.default.createElement(_icon.OutlineImageUpload, {
        className: "mx-auto text-gray-400",
        title: "Upload a file"
    }), /*#__PURE__*/ _react.default.createElement("div", {
        className: "flex mt-2 text-sm text-gray-600"
    }, /*#__PURE__*/ _react.default.createElement("label", {
        className: "bg-white rounded-md font-medium text-accent-600"
    }, "Upload a file", /*#__PURE__*/ _react.default.createElement("input", {
        accept: "image/*",
        name: "file-upload",
        type: "file",
        className: "absolute top-0 left-0 w-full h-full opacity-0 cursor-pointer",
        "data-testid": "file-upload-input",
        onChange: onFileChange,
        onDragEnter: onDragEnter,
        onDragLeave: onDragDone,
        onDragEnd: onDragDone,
        onDrop: onDragDone
    })), /*#__PURE__*/ _react.default.createElement("span", {
        className: "pl-1"
    }, "or drag and drop")), /*#__PURE__*/ _react.default.createElement("p", {
        className: "mt-1 text-xs text-gray-500"
    }, "PNG, JPG, GIF up to 10MB"))), errorMsg && /*#__PURE__*/ _react.default.createElement("p", {
        className: "mt-2 text-sm text-red-600"
    }, errorMsg)));
};

//# sourceMappingURL=ImageUpload.js.map